import { MapPin, Star, X } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ownLocations } from "@/lib/scope";

// Round L — several locations per person; the first is the default ("standaard").
export function UserLocationsEditor({ user, locations, disabled, onSave }) {
  const mine = ownLocations(user);
  const rest = locations.filter((l) => !mine.some((m) => m.toLowerCase() === l.toLowerCase()));
  const without = (name) => mine.filter((m) => m !== name);
  return (
    <div className="mt-2 flex items-center gap-2 flex-wrap" data-testid={`admin-user-locations-${user.id}`}>
      <MapPin size={11} className="text-tw-muted" strokeWidth={2.5} />
      {mine.map((loc, i) => (
        <span key={loc} data-testid={`admin-user-location-chip-${user.id}-${loc}`} data-default={i === 0 ? "true" : "false"}
          className={`inline-flex items-center gap-1 border px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-[0.12em] ${i === 0 ? "border-tw-yellow text-tw-yellow" : "border-tw text-white"}`}>
          {loc}{locations.length > 0 && !locations.some((l) => l.toLowerCase() === loc.toLowerCase()) && (
            <span className="text-[9px] text-tw-muted" data-testid={`admin-user-location-inactive-${user.id}-${loc}`}>(uit)</span>
          )}
          {i === 0 ? (
            <span className="text-[9px] opacity-80" data-testid={`admin-user-location-default-${user.id}`}>· standaard</span>
          ) : (
            <button type="button" disabled={disabled} onClick={() => onSave([loc, ...without(loc)])}
              data-testid={`admin-user-location-make-default-${user.id}-${loc}`} title="Maak standaard"
              className="inline-flex items-center gap-0.5 text-tw-muted hover:text-tw-yellow disabled:opacity-40">
              <Star size={9} strokeWidth={2.5} /> maak standaard
            </button>
          )}
          <button type="button" disabled={disabled} onClick={() => onSave(without(loc))} aria-label={`Verwijder ${loc}`}
            data-testid={`admin-user-location-remove-${user.id}-${loc}`} className="text-tw-muted hover:text-tw-red disabled:opacity-40">
            <X size={10} strokeWidth={2.5} />
          </button>
        </span>
      ))}
      {rest.length > 0 && (
        <Select value="" onValueChange={(v) => onSave([...mine, v])} disabled={disabled}>
          <SelectTrigger data-testid={`admin-user-location-select-${user.id}`}
            className="h-7 w-[150px] rounded-none bg-tw-black border-tw text-white text-xs focus:ring-0 focus:border-tw-yellow disabled:opacity-40">
            <SelectValue placeholder="+ Locatie" />
          </SelectTrigger>
          <SelectContent className="bg-tw-surface border-tw text-white rounded-none">
            {rest.map((loc) => (
              <SelectItem key={loc} value={loc} data-testid={`admin-user-location-option-${loc}`} className="rounded-none text-xs">{loc}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      <span className="text-[10px] text-tw-muted">{mine.length ? "De eerste is de standaard" : "Leeg = werkt over alle vestigingen"}</span>
    </div>
  );
}
